// Helper: abrir un archivo protegido con JWT en una nueva pestana.
// window.open no manda Authorization header, por eso hacemos fetch+blob.
// Sprint 35 (bonus fix S32 PDFs).
import apiClient from './apiClient';

/**
 * @param {string} path  path relativo al API_BASE, ej '/cotizaciones/5/pdf'
 * @param {string} [mimetype] opcional; por defecto se infiere de la respuesta.
 */
export default async function openProtectedFile(path, mimetype) {
  const token = apiClient.getAccessToken && apiClient.getAccessToken();
  const companyId = apiClient.getCurrentCompanyId
    && apiClient.getCurrentCompanyId();
  const headers = {};
  if (token) headers.Authorization = 'Bearer ' + token;
  if (companyId) headers['X-Company-Id'] = companyId;

  const res = await fetch(apiClient.API_BASE + path, { headers });
  if (!res.ok) {
    let msg = 'Error descargando (' + res.status + ')';
    try {
      const data = await res.json();
      if (data && (data.message || data.msg || data.error)) {
        msg = data.message || data.msg || data.error;
      }
    } catch { /* no json */ }
    throw new Error(msg);
  }
  const blob = mimetype
    ? new Blob([await res.arrayBuffer()], { type: mimetype })
    : await res.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
